import TermsOfService from 'components/Page/TermsOfService/TermsOfService';

export default TermsOfService;
